/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Mk_Calc_Per_MonthInputs */

const en_mk_calc_per_month = /** @type {(inputs: Mk_Calc_Per_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} / month`)
};

const id_mk_calc_per_month = /** @type {(inputs: Mk_Calc_Per_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} / bulan`)
};

/**
* | output |
* | --- |
* | "{total} / month" |
*
* @param {Mk_Calc_Per_MonthInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_calc_per_month = /** @type {((inputs: Mk_Calc_Per_MonthInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Calc_Per_MonthInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_calc_per_month(inputs)
	return en_mk_calc_per_month(inputs)
});